import { UpgradeRequiredError } from './apiClient';

export function getLinkedMapCreationFailure(error) {
  if (error instanceof UpgradeRequiredError) {
    return {
      message: error.message
        || 'You have reached your active-map limit. Deactivate a map in My maps, or activate Beta Pro.',
      upgradeRequired: true,
      capabilityKey: error.upgradeContext?.capabilityKey || 'maps.active.max',
    };
  }
  if (error?.createdMindmapId) {
    return {
      message: 'The map was created but could not be linked. It is available from your maps list.',
      upgradeRequired: false,
      capabilityKey: null,
    };
  }
  return {
    message: error?.message || 'Could not create the linked map. Try again.',
    upgradeRequired: false,
    capabilityKey: null,
  };
}

export async function createLinkedMapPortal({
  title,
  createMindMap,
  buildCommand,
  executeCommand,
}) {
  if (typeof createMindMap !== 'function' || typeof buildCommand !== 'function' || typeof executeCommand !== 'function') {
    throw new Error('Linked-map creation requires create, build, and execute operations');
  }

  const created = await createMindMap(title);
  if (!created?.id) throw new Error('The server did not create a map');

  try {
    const command = buildCommand(created);
    const nodeId = executeCommand(command);
    if (!nodeId) throw new Error('The linked-map command was not applied');
    return { mindmapId: created.id, nodeId, command };
  } catch (error) {
    error.createdMindmapId = created.id;
    throw error;
  }
}
